import { Form, Input } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import React from 'react';

import { ICurrency } from 'src/apis/common';
import { getNonRefundItems, IInvoice } from 'src/apis/Reporting/ChargeHistory';
import { IInvoiceItemRefundRequest } from 'src/apis/Reporting/Refund';
import RefundFormContext from './RefundFormContext';
import LineItemTable from './LineItemTable';
import Totals from './Totals';

const FormItem = Form.Item;
const { TextArea } = Input;

export interface IProps extends FormComponentProps {
  currency: ICurrency;
  invoice: IInvoice;
}

interface IState {
  totalRefund: number;
}

export const REFUND_FIELD_PREFIX = 'refundAmount';

const isRefundAmountField = (element: [string, any]) => { 
  return element[0].indexOf(REFUND_FIELD_PREFIX) === 0;
} 

// Takes the values of the form, filters down to the refund amounts, and totals their amounts
export const aggregateValues = (values: Object) => {
  return Object.entries(values)
    .filter(isRefundAmountField)
    .map(entry => entry[1])
    .reduce((aggregate, current) => {
      const val = Math.round(parseFloat(current) * 100);
      if(isNaN(val)) {
        return aggregate;
      }
      // Apply Math.round() to avoid sending things like 1714.9999999999998.
      return aggregate + val
    }, 0);
}

export const buildInvoiceItemRefundRequests = (values: Object) => {
    return Object.entries(values)
    .filter(isRefundAmountField)
    .reduce((aggregate, current) => {
      const val = Math.round(parseFloat(current[1]) * 100);
      const id = parseInt(current[0].slice(REFUND_FIELD_PREFIX.length));
      if(isNaN(id) || isNaN(val)) {
          return aggregate;
      }
      return [ ...aggregate, { invoiceItemID: id, amount: val }];
    }, [] as IInvoiceItemRefundRequest[]);
}

// Keeping this a class component for now for the parent component's ref to work.
class RefundForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      totalRefund: 0
    };
  }

  public render() {
    const { form, invoice } = this.props;
    const { getFieldDecorator } = form;
    const handleChange = () => {
      this.setState({totalRefund: aggregateValues(form.getFieldsValue())});
    };

    return (
      // Passing this.props to avoid unnecessary re-renders. See <https://reactjs.org/docs/context.html#caveats>.
      <RefundFormContext.Provider value={this.props}>
        <Form layout={'vertical'} onChange={handleChange}>
          <FormItem label='Note (required)'>
            {getFieldDecorator('note', {
              rules: [
                {
                  message: 'Please enter note',
                  required: true,
                  whitespace: true,
                },
              ],
            })(<TextArea rows={4}/>)}
          </FormItem>
          <LineItemTable invoiceItems={getNonRefundItems(invoice)} />
          <Totals invoice={invoice} totalRefund={this.state.totalRefund} />
        </Form>
      </RefundFormContext.Provider>
    );
  }
}

export default Form.create<IProps>()(RefundForm);
